import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, ClipboardCheck, Truck, AlertTriangle,
} from "lucide-react";
import { TotoAdaptiveDock } from "@/components/toto/TotoAdaptiveSurface";
import "./inventory-space.css";
import { useAuth } from "@/context/AuthContext";

/**
 * InventoryShell — the outer frame for every Inventory surface.
 *
 * Owns the single Inventory vessel. Only live operational tasks are in the
 * interior navigation; planned work does not occupy space or imply access.
 */

const SECTIONS = [
  { key: "dashboard",    label: "Dashboard",     icon: LayoutDashboard, path: "/operations/inventory",             built: true  },
  { key: "audit",        label: "OHQ Audit",  icon: ClipboardCheck,  path: "/operations/inventory/audit",       built: true  },
  { key: "receiving",    label: "Receiving",     icon: Truck,           path: "/operations/inventory/receiving",   built: true  },
  { key: "linen", label: "Linen", icon: Truck, path: "/operations/inventory/linen", built: true, roles: ['owner','coo','cfo','district_leader','leadership','boutique_manager'] },
  { key: "variances",    label: "Variance Review", icon: AlertTriangle, path: "/operations/inventory/variances",   built: true  },
];

export default function InventoryShell({ title, children, right = null, className = '' }) {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <main className={`inventory-space ${className}`} data-testid="inv-shell">
      <section className="inventory-space__vessel" aria-labelledby="inv-page-title">
        <header className="inventory-space__header">
          <div className="inventory-space__heading">
            <h1 id="inv-page-title" data-testid="inv-page-title">{title}</h1>
          </div>
          {right && <div className="inventory-space__header-action">{right}</div>}
        </header>

        <nav className="inventory-space__nav" aria-label="Inventory sections" data-testid="inv-rail">
          {SECTIONS.filter(s => !s.roles || s.roles.includes(user?.role)).map((s) => {
            const Icon = s.icon;
            const active =
              s.path === "/operations/inventory"
                ? location.pathname === s.path
                : location.pathname.startsWith(s.path);
            return (
              <NavLink
                to={s.path}
                key={s.key}
                data-testid={`inv-rail-${s.key}`}
                className={`inventory-space__nav-item ${active ? "is-active" : ""}`}
              >
                <Icon size={14} className="shrink-0" />
                <span>{s.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <section className="inventory-space__content" data-testid="inv-main">{children}</section>
      </section>
      <TotoAdaptiveDock active="workspace" destinations={[]} />
    </main>
  );
}

export { SECTIONS as INVENTORY_SECTIONS };
